import { createSlice } from '@reduxjs/toolkit';
import { EgonRouteDetailStateType } from 'src/types/egonRoute';

const initialState: EgonRouteDetailStateType = {
    data: null,
    loading: false,
    deleted: false,
    created: false,
    error: false,
};

export const egonRouteDetailSlice = createSlice({
    name: 'egonRouteDetail',
    initialState,
    reducers: {
        getEgonRouteDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getEgonRouteDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getEgonRouteDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createEgonRouteDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createEgonRouteDetailFetchSuccess: (state, action) => {
            // one row per country was created -> container navigates back to the list
            state.created = true;
            state.loading = false;
        },
        createEgonRouteDetailFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        updateEgonRouteDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateEgonRouteDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        updateEgonRouteDetailFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        deleteEgonRouteDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deleteEgonRouteDetailFetchSuccess: (state, action) => {
            state.deleted = true;
            state.loading = false;
        },
        deleteEgonRouteDetailFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        clearEgonRouteDetail: () => initialState,
    },
});

export const {
    getEgonRouteDetailFetch,
    getEgonRouteDetailFetchSuccess,
    getEgonRouteDetailFetchFailure,
    createEgonRouteDetailFetch,
    createEgonRouteDetailFetchSuccess,
    createEgonRouteDetailFetchFailure,
    updateEgonRouteDetailFetch,
    updateEgonRouteDetailFetchSuccess,
    updateEgonRouteDetailFetchFailure,
    deleteEgonRouteDetailFetch,
    deleteEgonRouteDetailFetchSuccess,
    deleteEgonRouteDetailFetchFailure,
    clearEgonRouteDetail,
} = egonRouteDetailSlice.actions;

export default egonRouteDetailSlice.reducer;
